// 预览模块
export default {
    Preview: {
        ExitPreview: 'Exit Preview',
        Tip: 'Tip: Currently on the preview page, answers will not be recorded',
        MobilePhone: 'Mobile phone',
        Computer: 'Computer',
        ReferenceThisTemplate: 'Reference this template',
        InReference: 'In reference'
    },
  };